"use client";

import React from "react";
import { LOCALES, LOCALE_NAMES, isLocale } from "./config";
import { useI18n } from "./I18nProvider";

/** Compact language selector; the choice is stored in a cookie and applies to the whole app. */
export function LanguageSwitcher({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <select
      className={className ?? "form-control"}
      style={style}
      value={locale}
      aria-label={t("common.language")}
      onChange={(e) => {
        if (isLocale(e.target.value)) setLocale(e.target.value);
      }}
    >
      {LOCALES.map((l) => (
        <option key={l} value={l}>
          {LOCALE_NAMES[l]}
        </option>
      ))}
    </select>
  );
}
